import React from 'react'
import { Field } from 'redux-form'
import { connect } from 'react-redux'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { FieldRow } from '../styled'

const ConditionOfPayment = (props) => {

  const {
    // props
    isEdit=false,
    isCreate=false,
    isDetail=false,
    
    poCompleteDetail,
    optionAmountOfPaymentType
  } = props

  return (
    <StdCard title='Condition of Payment' style={{ marginTop: '10px' }}>
      <FieldRow>
        <Field 
          name='totalAmount' 
          label='Total Amount (PO Ex. Vat)'
          type={type.number}
          fixedDecimalScale={true}
          decimalScale={2}
          editable={false}
          component={FieldInput}poCompleteDetail
          suffix={` ${poCompleteDetail.currencyCode||''}`}
        />
        <Field 
          name='deductOfRetention' 
          label='Deduct of retention (if any)'
          fixedDecimalScale={true}
          decimalScale={2}
          type={type.number}
          component={FieldInput}
          editable={!isDetail}
          suffix=' %'
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='amountOfPaymentType' 
          label='Amount of payment type'
          type={type.select}
          options={optionAmountOfPaymentType.data}
          loading={optionAmountOfPaymentType.loading}
          component={FieldInput}
          editable={!isDetail}
          className='halfRow'
          require
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='withholdingTax' 
          label='Deduct of Withholding Tax (if any)'
          type={type.select}
          options={[
            { text: '1% Transportation / Interest', value: 1 },
            { text: '2% Advertising Fees', value: 2 },
            { text: '3% Service / Royalties and Professional Fees', value: 3 },
            { text: '5% Rental / Prizes', value: 5 },
            { text: '10% Dividends', value: 10 },
          ]}
          component={FieldInput}
          editable={!isDetail}
          className='halfRow'
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='downPaymentOrDepositAmount' 
          label='Down Payment / Deposit Amount'
          className='halfRow'
          type={type.number}
          fixedDecimalScale={true}
          decimalScale={2}
          component={FieldInput}
          editable={!isDetail}
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='payerOfStampDuty' 
          label='Payer of Stamp Duty'
          className='halfRow'
          type={type.select}
          options={[
            { text: 'Vendor', value: 'vendor' },
            { text: 'Owner', value: 'owner' },
          ]}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return ({
    poCompleteDetail: state.contract.poCompleteDetail.data,
    optionAmountOfPaymentType: state.contract.optionAmountOfPaymentType
  })
}

const mapDispatchToProps = {
}


export default connect(mapStateToProps, mapDispatchToProps)(ConditionOfPayment)